import React from 'react'
import { Redirect, withRouter } from 'react-router-dom'

import store from '../store/Store'

import Navigation from '../components/navigation/Navigation'
import EditorContextMenu from '../components/editorContextMenu/EditorContextMenu'
import PageSelection from '../components/pageSelection/PageSelection'
import EditorTable from '../components/editorTable/EditorTable'
import EditorInformation from '../components/editorInformation/EditorInformation'
import EditorModal from '../components/editorModal/EditorModal'
import EditorOverview from '../components/editorOverview/EditorOverview'

import './editorOverviewView.scss'

type editorViewState = {
	article: any;
	history: any;
}

type editorViewProps = {
	article: any;
	history: any;
}

class EditorOverviewView extends React.Component<editorViewState, editorViewProps> {

	constructor(props) {
		super(props)

		this.state = {
			history: props.history,
			article: store.getState().article
		}
	}

	componentDidMount() {
		store.subscribe(() => {
			this.setState({
				article: store.getState().article
			})
		})
	}

	componentWillUnmount() {
		store.subscribe(() => {
			this.setState({
				article: store.getState().article
			})
		})
	}

	render() {
		const {
			article,
			history
		} = this.state

	  return (
	    <div 
	    	className='EditorOverviewView'
	    	style={{
	    		minWidth: '100vw',
	    		width: '100vw',
	    		minHeight: '100vh',
	    		height: '100vh'
	    	}}
	    >
	        <EditorOverview
	        	article={ article }
	          	history={ history }
	        />
	    </div>
	  )
	}
}

export default withRouter(EditorOverviewView)